import alertMessage from './alertMessage';

export default alertMessage;